module.exports = __webpack_public_path__ + "static/media/rocket.b98b2032.svg";